import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import styled from "styled-components";

import { Topic } from "shared/types";
import { Image } from "shared/components/atoms/Image";
import Grid from "features/media/components/atoms/Grid";
import {
  Reflection,
  reflective,
} from "features/media/components/atoms/Reflection";
import Blur from "features/media/components/atoms/Blur";
import { CircularProgress } from "@mui/material";

interface Props {
  topic: Topic;
}

const QuestionObjects: any = {
  復縁: {
    title: "元彼との相性診断テスト！",
    questions: [
      {
        id: 1,
        title: "あなたはお相手のどこに魅力を感じていましたか？",
        selectedAnswer: {},
        answers: [
          {
            id: 1,
            label: "a, 外見",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer25.png",
          },
          {
            id: 2,
            label: "b, 性格",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer26.png",
          },
          {
            id: 3,
            label: "c, お金",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer03.png",
          },
          {
            id: 4,
            label: "d, 感じなかった",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer04.png",
          },
        ],
        trackingId: "quiz_comp_1",
      },
      {
        id: 2,
        title: "今のお相手との関係は次のうちどれですか？",
        selectedAnswer: {},
        answers: [
          {
            id: 5,
            label: "a, 友達",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer05.png",
            resultUrl: "https://liny.link/r/1653832093-wa5v5wnv?lp=l1tybm",
          },
          {
            id: 6,
            label: "b, セフレ",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer27.png",
            resultUrl: "https://liny.link/r/1653832093-wa5v5wnv?lp=vgci3d",
          },
          {
            id: 7,
            label: "c, 他人",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer07.png",
            resultUrl: "https://liny.link/r/1653832093-wa5v5wnv?lp=h412ky",
          },
          {
            id: 8,
            label: "d, 顔見知り程度",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer08.png",
            resultUrl: "https://liny.link/r/1653832093-wa5v5wnv?lp=l1tybm",
          },
        ],
        trackingId: "quiz_comp_2",
      },
      {
        id: 3,
        title: "月に何回程度2人で過ごす時間がありましたか？",
        selectedAnswer: {},
        answers: [
          {
            id: 9,
            label: "a, ほぼ過ごしていない",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer09.png",
          },
          {
            id: 10,
            label: "b, 週1くらい",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer10.png",
          },
          {
            id: 11,
            label: "c, かなり頻繁に会う",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer11.png",
          },
          {
            id: 12,
            label: "d, 同棲なども含む",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer12.png",
          },
        ],
        trackingId: "quiz_comp_3",
      },
      {
        id: 4,
        title: "2人の連絡頻度はどれくらいでしたか？",
        selectedAnswer: {},
        answers: [
          {
            id: 13,
            label: "a, 何回かはやりとり",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer13.png",
          },
          {
            id: 14,
            label: "b, 頻繁にやりとり",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer14.png",
          },
          {
            id: 15,
            label: "c, たまにやりとり",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer15.png",
          },
          {
            id: 16,
            label: "d, ごくたまにやりとり",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer16.png",
          },
        ],
        trackingId: "quiz_comp_4",
      },
      {
        id: 5,
        title: "付き合っている時に喧嘩はありましたか？",
        selectedAnswer: {},
        answers: [
          {
            id: 17,
            label: "a, かなりあった",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer17.png",
          },
          {
            id: 18,
            label: "b, たまにあった",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer18.png",
          },
          {
            id: 19,
            label: "c, ほぼなかった",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer19.png",
          },
          {
            id: 20,
            label: "d, 一切なかった",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer20.png",
          },
        ],
        trackingId: "quiz_comp_5",
      },
      {
        id: 6,
        title: "セックスやキスの頻度はどの程度でしたか？",
        selectedAnswer: {},
        answers: [
          {
            id: 21,
            label: "a, 月に0回",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer28.png",
          },
          {
            id: 22,
            label: "b, 月に1~2回",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer29.png",
          },
          {
            id: 23,
            label: "c, 月に3回以上",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer30.png",
          },
          {
            id: 24,
            label: "d, せずに別れた",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer31.png",
          },
        ],
        trackingId: "quiz_comp_6",
      },
    ],
    query:
      "?utm_source=media&utm_medium=referral&utm_campaign=mediawebLINE&clid=_bwykpbMaOMM6JP7vFy_VA",
  },
  片思い: {
    title: "お相手との相性診断テスト！",
    questions: [
      {
        id: 1,
        title: "あなたはお相手のどこに魅力を感じていますか？",
        selectedAnswer: {},
        answers: [
          {
            id: 1,
            label: "a, 外見",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer25.png",
          },
          {
            id: 2,
            label: "b, 性格",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer26.png",
          },
          {
            id: 3,
            label: "c, お金",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer03.png",
          },
          {
            id: 4,
            label: "d, 感じていない",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer04.png",
          },
        ],
        trackingId: "quiz_comp_片思い_1",
      },
      {
        id: 2,
        title: "お相手との関係は次のうちどれですか？",
        selectedAnswer: {},
        answers: [
          {
            id: 5,
            label: "a, 友達",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer05.png",
            resultUrl: "https://liny.link/r/1653832093-wa5v5wnv?lp=l1tybm",
          },
          {
            id: 6,
            label: "b, セフレ",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer27.png",
            resultUrl: "https://liny.link/r/1653832093-wa5v5wnv?lp=vgci3d",
          },
          {
            id: 7,
            label: "c, 他人",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer07.png",
            resultUrl: "https://liny.link/r/1653832093-wa5v5wnv?lp=h412ky",
          },
          {
            id: 8,
            label: "d, 顔見知り程度",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer08.png",
            resultUrl: "https://liny.link/r/1653832093-wa5v5wnv?lp=l1tybm",
          },
        ],
        trackingId: "quiz_comp_片思い_2",
      },
      {
        id: 3,
        title: "お相手とはどの程度LINEや電話をしますか？",
        selectedAnswer: {},
        answers: [
          {
            id: 9,
            label: "a, 1日に1~2回",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer13.png",
          },
          {
            id: 10,
            label: "b, 1日に3回以上",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer14.png",
          },
          {
            id: 11,
            label: "c, 2日に1回程度",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer15.png",
          },
          {
            id: 12,
            label: "d, ほぼない",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer16.png",
          },
        ],
        trackingId: "quiz_comp_片思い_3",
      },
      {
        id: 4,
        title: "付き合ったら勉強や仕事に支障が出る可能性はありますか？",
        selectedAnswer: {},
        answers: [
          {
            id: 13,
            label: "a, かなりある",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer17.png",
          },
          {
            id: 14,
            label: "b, 少しある",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer18.png",
          },
          {
            id: 15,
            label: "c, ほぼない",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer19.png",
          },
          {
            id: 16,
            label: "d, 一切ない",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer20.png",
          },
        ],
        trackingId: "quiz_comp_片思い_4",
      },
      {
        id: 5,
        title: "共通の趣味はありますか？",
        selectedAnswer: {},
        answers: [
          {
            id: 17,
            label: "a, かなりある",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer32.png",
          },
          {
            id: 18,
            label: "b, 少しある",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer33.png",
          },
          {
            id: 19,
            label: "c, あまりない",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer34.png",
          },
          {
            id: 20,
            label: "d, 全くない",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer35.png",
          },
        ],
        trackingId: "quiz_comp_片思い_5",
      },
      {
        id: 6,
        title: "お相手とどの程度直接会う機会がありますか？",
        selectedAnswer: {},
        answers: [
          {
            id: 21,
            label: "a, 月に0回",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer36.png",
          },
          {
            id: 22,
            label: "b, 月に1~2回",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer37.png",
          },
          {
            id: 23,
            label: "c, 月に3~4回",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer38.png",
          },
          {
            id: 24,
            label: "d, 月に4回以上",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer39.png",
          },
        ],
        trackingId: "quiz_comp_片思い_6",
      },
    ],
    query:
      "?utm_source=media&utm_medium=referral&utm_campaign=mediawebLINE&clid=Y2--3HNrHxNRmMUhrPXGDw",
  },
  不倫: {
    title: "お相手との相性診断テスト！",
    questions: [
      {
        id: 1,
        title: "あなたはお相手のどこに魅力を感じていますか？",
        selectedAnswer: {},
        answers: [
          {
            id: 1,
            label: "a, 外見",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer25.png",
          },
          {
            id: 2,
            label: "b, 性格",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer26.png",
          },
          {
            id: 3,
            label: "c, お金",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer03.png",
          },
          {
            id: 4,
            label: "d, 感じなかった",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer04.png",
          },
        ],
        trackingId: "quiz_comp_不倫_1",
      },
      {
        id: 2,
        title: "お相手と一緒にいて得られる感情は次のうちどれに近いですか？",
        selectedAnswer: {},
        answers: [
          {
            id: 5,
            label: "a, 安心感",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer40.png",
            resultUrl: "https://liny.link/r/1653832093-wa5v5wnv?lp=l1tybm",
          },
          {
            id: 6,
            label: "b, ドキドキ感",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer41.png",
            resultUrl: "https://liny.link/r/1653832093-wa5v5wnv?lp=vgci3d",
          },
          {
            id: 7,
            label: "c, 背徳感",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer42.png",
            resultUrl: "https://liny.link/r/1653832093-wa5v5wnv?lp=h412ky",
          },
          {
            id: 8,
            label: "d, 信頼感",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer43.png",
            resultUrl: "https://liny.link/r/1653832093-wa5v5wnv?lp=l1tybm",
          },
        ],
        trackingId: "quiz_comp_不倫_2",
      },
      {
        id: 3,
        title: "お相手とはどの程度LINEや電話をしますか？",
        selectedAnswer: {},
        answers: [
          {
            id: 9,
            label: "a, 1日に1~2回",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer13.png",
          },
          {
            id: 10,
            label: "b, 1日に3回以上",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer14.png",
          },
          {
            id: 11,
            label: "c, 2日に1回程度",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer15.png",
          },
          {
            id: 12,
            label: "d, ほぼない",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer16.png",
          },
        ],
        trackingId: "quiz_comp_不倫_3",
      },
      {
        id: 4,
        title: "お相手とどの程度直接会いますか？",
        selectedAnswer: {},
        answers: [
          {
            id: 13,
            label: "a, 月に0回",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer36.png",
          },
          {
            id: 14,
            label: "b, 月に1~2回",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer37.png",
          },
          {
            id: 15,
            label: "c, 月に3~4回",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer38.png",
          },
          {
            id: 16,
            label: "d, 月に4回以上",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer39.png",
          },
        ],
        trackingId: "quiz_comp_不倫_4",
      },
      {
        id: 5,
        title: "喧嘩をすることはありますか？",
        selectedAnswer: {},
        answers: [
          {
            id: 17,
            label: "a, かなりある",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer17.png",
          },
          {
            id: 18,
            label: "b, たまにある",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer18.png",
          },
          {
            id: 19,
            label: "c, ほぼない",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer19.png",
          },
          {
            id: 20,
            label: "d, 一切ない",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer20.png",
          },
        ],
        trackingId: "quiz_comp_不倫_5",
      },
      {
        id: 6,
        title: "セックスやキスの頻度はどの程度ですか？",
        selectedAnswer: {},
        answers: [
          {
            id: 21,
            label: "a, 月に0回",
            value: "a",
            imageUrl: "https://cdn.miror.jp/item/answer45.png",
          },
          {
            id: 22,
            label: "b, 月に1~2回",
            value: "b",
            imageUrl: "https://cdn.miror.jp/item/answer46.png",
          },
          {
            id: 23,
            label: "c, 月に3回以上",
            value: "c",
            imageUrl: "https://cdn.miror.jp/item/answer47.png",
          },
          {
            id: 24,
            label: "d, 月に4回以上",
            value: "d",
            imageUrl: "https://cdn.miror.jp/item/answer48.png",
          },
        ],
        trackingId: "quiz_comp_不倫_6",
      },
    ],
    query:
      "?utm_source=media&utm_medium=referral&utm_campaign=mediawebLINE&clid=N23hsq8BOF9_lIY9v6YR1w",
  },
};

export default function Quiz({ topic }: Props) {
  const [currentIndex, setCurrentIndex]: any = useState(0);
  const [finished, setFinished] = useState(false);
  const [result, setResult]: any = useState(false);
  const questionObject = topic.freeFortuneName
    ? QuestionObjects[topic.freeFortuneName]
    : null;

  const { title, questions, query } = questionObject;
  const currentQuestion = questions[currentIndex];

  const slideNextQuestion = () => {
    const nextIndex = currentIndex + 1;
    setTimeout(() => setCurrentIndex(nextIndex), 1000);
  };

  const onClickAnswer = (answer: any) => {
    currentQuestion.selectedAnswer = answer;
    currentIndex == questions.length - 1
      ? setFinished(true)
      : slideNextQuestion();
  };

  const showResult = () => {
    setTimeout(() => setResult(finished), 3000);
  };

  useEffect(showResult, [finished]);

  if (!questionObject) {
    return null;
  }

  return (
    <Carousel
      axis="vertical"
      centerMode
      dynamicHeight
      showArrows={false}
      showStatus={false}
      showIndicators={false}
      showThumbs={false}
      swipeable={false}
      selectedItem={currentIndex}
    >
      {questions.map((question: any, index: number) => (
        <BackGround
          key={question.id}
          id={`CarouselItem-${index}`}
          src="/images/quiz-component-bg.png"
        >
          <Header>
            <Image
              src="https://cdn.miror.jp/item/free_fortune_component_header_image_02.png"
              width={576}
              height={98}
              layout="responsive"
              priority
            />
            <H5>
              <Text>まずはここから♡</Text>
              {title}
            </H5>
            <Image
              src="https://cdn.miror.jp/item/free_fortune_component_header_image_03.png"
              width={640}
              height={140}
              layout="responsive"
              priority
            />
          </Header>
          <Question>
            {!finished && (
              <Progress>Question ( {`${question.id} / 6`} )</Progress>
            )}
            <QuestionTitle>
              {!finished && question.title}
              {finished &&
                (result ? "結果が出ました🙌" : "診断中...少々お待ちください")}
            </QuestionTitle>
          </Question>
          {result ? (
            <>
              <Result>
                <ResultText>あなたとお相手の相性は...</ResultText>
                <Percentage>
                  <Grid direction="row" alignItems="center">
                    <Blur blurRadius={10}>100</Blur>
                    %🌈
                  </Grid>
                </Percentage>
                <Blur>2人の相性は最高！ どんな関係でも上手くいきます</Blur>
              </Result>
              <Link
                href={`https://miror.jp/無料占い/${topic.freeFortuneName}${query}`}
              >
                <a>
                  今すぐ無料で結果を見る
                  <Reflection />
                </a>
              </Link>
            </>
          ) : (
            <Answers>
              {question.answers.map((answer: any) => (
                <Answer key={answer.id} onClick={onClickAnswer}>
                  <AnswerLabel>{answer.label}</AnswerLabel>
                  <Image
                    src={answer.imageUrl}
                    width={100}
                    height={100}
                    layout="responsive"
                    unoptimized
                  />
                </Answer>
              ))}
              {finished && !result && (
                <Indicator>
                  <CircularProgress style={{ color: "#CF73B2" }} />
                </Indicator>
              )}
            </Answers>
          )}
          <Text>
            ※情報や回答は保存されず
            <br />
            一切流出しません
          </Text>
        </BackGround>
      ))}
    </Carousel>
  );
}

const BackGround = styled.div`
  background-image: url(${({ src }: { src: string }) => src});
  background-size: cover;
  padding: 24px;
  border-radius: 16px;
  text-align: center;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Text = styled.div`
  font-weight: bold;
  font-size: 12px;
  color: #fff;
  margin-bottom: 4px;
  line-height: 18px;
`;

const H5 = styled.h5`
  font-weight: bold;
  color: #fff;
`;

const Question = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #d47373;
  width: 100%;
  border-radius: 56px;
  height: 80px;
  padding: 0 16px;
  margin-bottom: 16px;
  color: #fff;
`;

const Progress = styled.div`
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 8px;
`;

const QuestionTitle = styled.div`
  font-size: 14px;
  line-height: 18px;
`;

const Answers = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
`;

const Answer = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50%;
  color: #fff;
  font-size: 20px;
  margin-bottom: 16px;
  background: transparent;
  border: none;

  &:nth-child(odd) {
    padding-right: 16px;
  }

  &:nth-child(even) {
    padding-left: 16px;
  }
`;

const AnswerLabel = styled.div`
  font-size: 16px;
  margin-bottom: 8px;
  word-break: keep-all;
  white-space: nowrap;
`;

const Indicator = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const Result = styled.div`
  background: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  padding: 48px 24px;
`;

const ResultText = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
`;

const Percentage = styled.div`
  font-size: 40px;
  font-weight: bold;
  margin: 8px 0;
`;

const Link = reflective(styled.a`
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  background: #f44a4a;
  border-radius: 40px;
  padding: 20px 8px;
  display: block;
  width: 100%;
  text-align: center;
  margin-bottom: 16px;
`);
